import store from '@/store'
import { getMessage } from '@/components/Message/js/Messages.js'

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function getRooms(roomId, options = {}) {
    const { silentLoading = false, autoScroll = !silentLoading } = options;

    let json = {
        pathUrl: store.state.urlPathAuth,
        method: 'get',
        alert: false,
        url: 'rooms',
        loading: !silentLoading,
        update: 'UpdateRooms',
        postData: {}
    }

    //  ВАЖНО — return
    return store.dispatch('axiosData', json)
        .then(response => {

            if (roomId) {
                let ind = response.data.findIndex(el => el.roomId == roomId)

                if (ind === -1) {
                    const currentRoom = store.state.RoomOpen;
                    const fallbackRoom =
                        currentRoom && String(currentRoom.roomId) === String(roomId)
                            ? currentRoom
                            : {
                                roomId: Number(roomId),
                                roomName: "",
                                avatar: null,
                                unreadCount: 0,
                                index: 0,
                                creator: null,
                                lastMessage: null,
                                group: 1,
                                user_id: null,
                                users: [],
                            };

                    store.state.RoomOpen = fallbackRoom;
                    return getMessage(roomId, { silentLoading, autoScroll })

                } else {
                    store.state.RoomOpen = response.data[ind]

                    return getMessage(roomId, { silentLoading, autoScroll })
                    //store.state.SelectedRoom = ind
                }

            } else {
                store.state.RoomOpen = response.data[0]

                if (store.state.RoomOpen?.roomId) {
                    return getMessage(store.state.RoomOpen?.roomId, { silentLoading, autoScroll })
                }

            }

            return response // 👈 можно вернуть дальше
        })
}
